import { render, staticRenderFns } from "./CloseRegisterHistory.vue?vue&type=template&id=06be7019&scoped=true&"
import script from "./CloseRegisterHistory.vue?vue&type=script&lang=js&"
export * from "./CloseRegisterHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06be7019",
  null
  
)

export default component.exports